import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"
import { Observable } from "rxjs"
import { map, catchError } from "rxjs/operators"
import { environment } from "../../environments/environment"
import { HelpersService } from "./helpers.service"
import { Router } from "@angular/router"

@Injectable({
	providedIn: "root"
})
export class BaseService extends HelpersService {
	private USER_GROUP_URL = "/api2/marketing/admin/user/groups-clone"
	private COMPANIES_URL = "/api2/marketing/user/companies"
	private P2P_SERVICES_URL = "/api2/marketing/services/p2p"
	private PON_SERVICES_URL = "/api2/marketing/services/pon"
	private TRANSPORT_COLO_URL = "/api2/marketing/services/transport-colo"

	constructor(
		public http: HttpClient,
		public router: Router
	) {
		super(http, router)
	}

	getUserGroups(): Observable<any> {
		return this.http.get(environment.DOMAIN_URL + this.USER_GROUP_URL).pipe(map((res: any) => res as any))
	}

	getCompanies(): Observable<any> {
		return this.http
			.get(environment.DOMAIN_URL + this.COMPANIES_URL, this.getHTTPHeader(true))
			.pipe(map((res: any) => res as any))
	}

	getServicesP2P(): Observable<any> {
		return this.http
			.get(environment.DOMAIN_URL + this.P2P_SERVICES_URL, this.getHTTPHeader(true))
			.pipe(map((res: any) => res as any))
	}

	getServicesPon(): Observable<any> {
		return this.http
			.get(environment.DOMAIN_URL + this.PON_SERVICES_URL, this.getHTTPHeader(true))
			.pipe(map((res: any) => res as any))
	}

	getServicesTransportAndColo(): Observable<any> {
		return this.http
			.get(environment.DOMAIN_URL + this.TRANSPORT_COLO_URL, this.getHTTPHeader(true))
			.pipe(map((res: any) => res as any))
	}

	uploadFile(req): Observable<any> {
		// Fake api
		return this.http
			.post<any>(environment.DOMAIN_URL + "/api2/marketing/massivep2p/upload", req, this.getHTTPHeader(true))
			.pipe(
				map(result => {
					return result
				})
			)
			.pipe(
				catchError(error => {
					return this.handleError(error, "uploadFile")
				})
			)
	}

	reportIssue(req): Observable<any> {
		return this.http.post(environment.DOMAIN_URL + "/api2/report/issue", req, this.getHTTPHeader(true)).pipe(
			catchError(error => {
				return this.handleError(error, "reportIssue")
			})
		)
	}

	sendToSalesforce(id): Observable<any> {
		let url = environment.DOMAIN_URL + "/api2/marketing/p2p/salesforce/single-share"
		const body = { id: id }
		return this.http
			.post<any>(url, body, this.getHTTPHeader(true))
			.pipe(
				map(result => {
					return result
				})
			)
			.pipe(
				catchError(error => {
					this.showErrorMsg(error.error.error.message)
					return this.handleError(error, "sendToSalesforce")
				})
			)
	}
}
